/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.lineitems.rpc.LineItemPreviewRpc
 */

export const previewLineItemsRpc = {
  serviceName: 'com.hubspot.lineitems.rpc.LineItemPreviewRpc',
  rpcName: 'previewLineItems',
  auth: 'app',
  fingerprint: '0AkBb0U8IR4v6Re18ek7bN8HDZ80asXW',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const previewBundleItemsRpc = {
  serviceName: 'com.hubspot.lineitems.rpc.LineItemPreviewRpc',
  rpcName: 'previewBundleItems',
  auth: 'app',
  fingerprint: 'ObeVB6Z1QMR5OiFoTkitud8HDZ80asXW',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};